// Adjust padding-bottom for `back` sections adjacent to `front` sections
$(function () {
  $('.back + .front').prev().addClass('back--adjacent-front')
  $('.image-wide.front + .back').prev().addClass('front-wide--adjacent-back')
  $('.video-wide.front + .back').prev().addClass('front-wide--adjacent-back')
  $('.video-looping-wide.front + .back').prev().addClass('front-wide--adjacent-back')
})
